<!-- <p>event-details works!</p> -->
<div class="main-events-div">
    <div *ngIf="!wrongAccount">
        <div class="title-div">
            <span *ngIf="ruleEvent" style="font-size: large; font-weight: bolder;">Rule Event Triggered by
                {{ruleEvent.AssetName}}</span>
            <span *ngIf="offlineEvent" style="font-size: large; font-weight: bolder;">Offline Event Triggered by {{
                offlineEvent.SensorName }}</span>
            <span *ngIf="webhookEvent" style="font-size: large; font-weight: bolder;">Webhook Event Triggered by {{
                webhookEvent.ClientWebhookID }}</span>
            <span *ngIf="deviationEvent" style="font-size: large; font-weight: bolder;">Deviation Event Triggered by {{
                deviationEvent.AssetName }} - {{deviationEvent.AssetDescription}}</span>
            <span class="toolbar-spacer"></span>
            <button mat-raised-button (click)="back()" style="margin-bottom: 0.5em;" class="app-icon--back">
                <mat-icon />
                <span>Back</span>
            </button>
        </div>
        <div class="button-div">
            <button mat-raised-button color="primary" [disabled]="!asset" *ngIf="asset" (click)="goToAssetLocation()"
                class="app-icon--goto">
                <span>Go To Asset</span>
                <mat-icon />
            </button>
            <button mat-raised-button color="primary" [disabled]="!webhookEvent" *ngIf="webhookEvent"
                routerLink="/setup/integration-management/{{OrganisationUID}}/integration/{{webhookEvent.WebhookUID}}"
                [queryParams]="{ webhooktypeid: webhookEvent.WebhookType}" class="app-icon--goto">
                <span>Go To Webhook</span>
                <mat-icon />
            </button>
            <button mat-raised-button color="primary" *ngIf="rule"
                routerLink="/{{accountID}}/organisation/{{OrganisationUID}}/rules/{{rule.RuleID}}"
                style="margin-left: 0.5em;" class="app-icon--goto">
                <span>Go To Rule</span>
                <mat-icon />
            </button>
            <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="OpenRule(rule)"
                *ngIf="rule && asset">
                <span>View Rule</span>
                <mat-icon>visibility_on</mat-icon>
            </button>
            <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewDistribution()"
                *ngIf="deviationEvent && asset">
                <span>View Model</span>
                <mat-icon>visibility_on</mat-icon>
            </button>
            <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewCMMS()"
                *ngIf="CMMSCase && checkFeature(AccountFeatures.SAP)">
                <span>view Case</span>
                <mat-icon>visibility_on</mat-icon>
            </button>
            <span class="toolbar-spacer"></span>
            <button mat-raised-button (click)="goToEvents()" style="margin-bottom: 0.5em;">
                <mat-icon>notifications</mat-icon>
                <span>Events</span>
            </button>
        </div>
        <ejs-accordion *ngIf="showChart">
            <e-accordionitems>
                <e-accordionitem [expanded]="true">
                    <ng-template #header>
                        <span>Chart</span>
                    </ng-template>
                    <ng-template #content>
                        <div class="alignRow alignColumn">
                            <span *ngIf="visibleStartDate && visibleEndDate"
                                matTooltip="{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}"
                                class="hideoverflow">{{getShortDate(visibleStartDate)}} -
                                {{getShortDate(visibleEndDate)}}
                            </span>
                        </div>
                        <div class="graph alignColumn alignRow">
                            <ejs-chart #myChart2 id="myChart2" [primaryXAxis]='sensorXAxis'
                                [zoomSettings]="zoomSettings" [legendSettings]='legend' [tooltip]='tooltipSettings'
                                [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings"
                                [selectionMode]=' selectionMode' [palettes]='palette' [height]="chartHeight"
                                [width]="chartWidth" (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)"
                                (chartMouseDown)="checkClick($event)" (tooltipRender)="onTooltipRender($event)">
                            </ejs-chart>
                        </div>
                        <div class="alignColumn alignRow">
                            <app-duration-selector [(duration)]="strDuration"
                                (durationChange)="selectTime($event)"></app-duration-selector>
                            <!-- <mat-chip-set aria-label="Time selection" class="chip-set">
                                <mat-chip *ngFor="let duration of chipDurations"
                                    [ngStyle]="{'background-color': strDuration === duration.time ? 'lightblue' : ''}"
                                    (click)="selectTime(duration.time)" matTooltip={{duration.toolTip}}>
                                    {{duration.text}}
                                </mat-chip>
                            </mat-chip-set> -->
                        </div>

                        <!-- Spinner -->
                        <div class="local-spinner" *ngIf="spinner">
                            <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                                [attr.x-contenttype]="'image/gif'" alt="Loading..." />
                        </div>
                    </ng-template>
                </e-accordionitem>
            </e-accordionitems>
        </ejs-accordion>
        <br>
        <div class="rule-event-details" *ngIf="rule">
            <span>Timestamp: {{ convertEpoch(ruleEvent.TimeStamp) }}</span>
            <span *ngIf="rule">Rule Name: <b>{{rule.RuleDescription}}</b></span>
            <span *ngIf="rule.RuleMessage">Message:</span>
            <span *ngIf="rule.RuleMessage">{{rule.RuleMessage}}</span>
            <span *ngIf="rule.RuleDef" style="font-weight: bolder;">Condition:</span>
            <span style="font-weight: bolder;">{{ ruleEvent.RuleText }}</span>
            <span *ngIf="rule.RuleDef" style="font-weight: bolder;">Values:</span>
            <span style="font-weight: bolder;">{{ ruleEvent.RuleValues }}</span>
            <span style="font-weight: bolder;" *ngIf="ruleCondition != ''">Operator:</span>
            <span style="font-weight: bolder;" *ngIf="ruleCondition != ''">{{ ruleCondition }}</span>
            <span style="font-weight: bolder;">Trigger Time:</span>
            <span style="font-weight: bolder;">{{ rule.TriggerTime }} Minutes</span>
        </div>
        <div class="rule-event-details" *ngIf="offlineEvent">
            <span>{{ convertEpoch(offlineEvent.TimeStamp) }}</span>
            <span *ngIf="offlineEvent">Sensor Name: {{offlineEvent.SensorName}}</span>
            <span *ngIf="offlineEvent">Message: {{offlineEvent.OfflineEventText}}</span>
        </div>
        <div class="rule-event-details" *ngIf="webhookEvent">
            <span>{{ convertEpoch(webhookEvent.TimeStamp) }}</span>
            <span *ngIf="webhookEvent">Webhook: {{webhookEvent.ClientWebhookID}}</span>
            <span *ngIf="webhookEvent">Message: {{webhookEvent.WebhookEventText}}</span>
            <span *ngIf="webhookEvent">Webhook Description:</span>
            <span *ngIf="webhookEvent">{{ webhookEvent.Description }}</span>
            <span *ngIf="webhookEvent" style="font-weight: bolder;">Event Type: {{ webhookEventType }}</span>
        </div>
        <div class="rule-event-details" *ngIf="deviationEvent">
            <span style="font-weight: bold;">{{ convertEpoch(deviationEvent.Timestamp) }}</span>
            <span *ngIf="deviationEvent">Asset: <b>{{deviationEvent.AssetName}} -
                    {{deviationEvent.AssetDescription}}</b></span>
            <span *ngIf="deviationEvent"> DataPoint: <b>{{deviationEvent.DPTitle}}</b></span>
            <span *ngIf="deviationEvent"> Z-Score: {{deviationEvent.ZScore}}; Tolerance: {{
                deviationEvent.AcceptableDeviation }}</span>
            <span *ngIf="deviationEvent"> Message:</span>
            <span *ngIf="deviationEvent && deviationEvent.Sensitivity == 50">
                DataPoint <b>{{deviationEvent.DPTitle}}</b> had an average Z-Score of {{deviationEvent.ZScore}} which is
                above the Tolerance of {{deviationEvent.AcceptableDeviation}}.
            </span>
            <span *ngIf="deviationEvent && deviationEvent.Sensitivity != 50">
                <b>{{deviationEvent.PercentageDeviated}}%</b> of the values for DataPoint
                <b>{{deviationEvent.DPTitle}}</b> were above the Tolerance of {{deviationEvent.AcceptableDeviation}}
                with an average Z-Score of {{deviationEvent.ZScore}}.
            </span>
        </div>
        <br *ngIf="deviationEvent">
        <span style="display: flex; width: 100%; font-size: larger; font-weight: bold;" class="alignColumn"
            *ngIf="deviationEvent">Model Details</span>
        <div class="rule-event-details" *ngIf="deviationEvent && existingDistribution">
            <span>Model Type:</span>
            <span>Normal Distribution</span>
            <span>Created At: </span>
            <span style="font-weight: bold;">{{ convertEpoch(existingDistribution.CreatedAt) }}</span>
            <span>Is this an active Model?</span>
            <span> <b>{{existingDistribution.MostRecent ? " Yes. " : " No. "}}</b> This Model
                <b>{{existingDistribution.MostRecent ? " is " : " is not "}}</b> an active Model on this Asset.</span>
        </div>
        <div class="deleted-model alignColumn" *ngIf="deviationEvent && !existingDistribution">
            <span>This model has been deleted since this event was created.</span>
        </div>
        <br>
        <ejs-accordion>
            <e-accordionitems>
                <e-accordionitem [expanded]="expanded">
                    <ng-template #header>
                        <span *ngIf="comments">Comments ({{comments.length}})</span>
                        <span *ngIf="!comments">Comments (0)</span>
                    </ng-template>
                    <ng-template #content>
                        <div *ngIf="comments && comments.length > 0">
                            <div class="comment-info-div">
                                <span>Comment Text</span>
                                <span>Timestamp</span>
                                <span>Added By</span>
                            </div>
                            <div *ngFor="let c of comments">
                                <div class="comment-div">
                                    <span>{{ c.CommentText }}</span>
                                    <span *ngIf="c.Timestamp">{{ convertEpoch(c.Timestamp) }}</span>
                                    <span *ngIf="c.AddedByUserID">{{ c.AddedByUserID }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- [matMenuTriggerFor]="AddCommentMenu" -->
                        <div class="add-comment-button-div">
                            <div class="add-button app-icon app-icon--add" (click)="addCommentNew()">
                                <span>Add Comment</span>
                                <mat-icon />
                            </div>
                        </div>
                    </ng-template>
                </e-accordionitem>
            </e-accordionitems>
        </ejs-accordion>
        <div *ngIf="eventType != 3" class="acknowledge-button alignRow">
            <button mat-raised-button (click)="acknowledgeEvent(true)"
                *ngIf="!Acknowledged && (eventType == 2 || eventType == 4)">
                <mat-icon>done</mat-icon>
                <span>Acknowledge</span>
            </button>
            <button mat-raised-button (click)="acknowledgeEvent(false)"
                *ngIf="eventType == 1 || (eventType == 4 && Acknowledged)" [disabled]="Acknowledged">
                <mat-icon>done</mat-icon>
                <span>Acknowledge</span>
            </button>
            <button mat-raised-button (click)="reopenEvent(true)" *ngIf="Acknowledged && eventType == 2">
                <mat-icon>restore</mat-icon>
                <span>Re-Open Event</span>
            </button>
        </div>
        <span class="acknowledge-button alignRow"
            *ngIf="Acknowledged && eventType==2 && ruleEvent && ruleEvent.AcknowledgedUser">Acknowledged by {{
            ruleEvent.AcknowledgedUser }} on {{
            convertEpoch(ruleEvent.AcknowledgedTimestamp) }}</span>
        <span class="acknowledge-button alignRow"
            *ngIf="Acknowledged && eventType==1 && offlineEvent && offlineEvent.AcknowledgedUser">Acknowledged by {{
            offlineEvent.AcknowledgedUser }} on {{
            convertEpoch(offlineEvent.AcknowledgedTimestamp) }}</span>
        <span class="acknowledge-button alignRow"
            *ngIf="Acknowledged && eventType==4 && deviationEvent && deviationEvent.AcknowledgedUser && deviationEvent.AcknowledgedTimestamp">Acknowledged
            by {{
            deviationEvent.AcknowledgedUser }} on {{
            convertEpoch(deviationEvent.AcknowledgedTimestamp) }}</span>
    </div>
    <div *ngIf="deviationEvent" class="image-div">
        <img style="max-height: 60vh; max-width: 100%;" [src]="'data:image/png;base64,' + deviationEvent.EncodedImage"
            alt="Distribution Image" />
    </div>
    <hr *ngIf="displayTimeline && !wrongAccount && eventType == 2">
    <ejs-accordion id="timeline-accordion" *ngIf="displayTimeline && !wrongAccount && eventType == 2">
        <e-accordionitems>
            <e-accordionitem>
                <ng-template #header>
                    <span>Timeline</span>
                </ng-template>
                <ng-template #content>
                    <div>
                        <ng-container *ngTemplateOutlet="timeline"></ng-container>
                    </div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
    <div *ngIf="wrongAccount" class="wrong-account-div alignColumn">
        <span style="font-size: larger; font-weight: bold;">Wrong Account</span><br>
        <span>This event exists on a different account. If you have access to the correct account, please select that
            account to view the event.</span>
    </div>
</div>

<mat-menu #AddCommentMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
    <div class="new-comment-div">
        <div>Write a comment</div>
        <ejs-inplaceeditor #inplace_editor2 mode="Inline" [ariaRequired]="true" name="CommentText" type="Text"
            [enablePersistence]="false" [value]='' editableOn="Click" showButtons="1" mode="Inline"
            (actionSuccess)="AddComment($event)" style="margin-left: 1em;">
        </ejs-inplaceeditor>

        <ejs-textarea floatLabelType="Auto" cssClass="e-outline" placeholder="Outlined" rows="5"
            cols="250"></ejs-textarea>
    </div>
</mat-menu>

<ng-template #timeline>
    <div *ngIf="Timeline && Timeline.length > 0" class="timeline-div alignColumn">
        <ejs-timeline orientation="Vertical" alignment="Before" [template]="customTemplate" cssClass="custom-timeline">
            <e-items>
                <e-item *ngFor="let item of timelineItems" [dotCss]="item.dotCss" [content]="item.content"
                    [oppositeContent]="item.oppositeContent">
                </e-item>
            </e-items>
            <ng-template #customTemplate let-data="">
                <div class='template-container'>
                    <div class="progress-line" [ngClass]="{'last': checkNotLast(data)}">
                        <div class="indicator alignRow alignColumn">
                            <mat-icon *ngIf="data.item.dotCss == '1'"
                                style="z-index: 1001;">notifications_active</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '2'" style="z-index: 1001;">done</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '3'" style="z-index: 1001;">restore</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '4' || data.item.dotCss == '6'"
                                style="z-index: 1001;">comment</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '5'" style="z-index: 1001;">content_paste</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '7'"
                                style="z-index: 1001;">assignment_turned_in</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '8' || data.item.dotCss == '9'"
                                style="z-index: 1001;">rules</mat-icon>
                            <mat-icon *ngIf="data.item.dotCss == '10'" style="z-index: 1001;">edit</mat-icon>
                        </div>
                    </div>
                    <div class="timeline-content">
                        <div class="content-container alignRow">
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '1' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '2' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Acknowledged</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '3' && buildObject(data.item.content, data.item.dotCss) as RuleEvent">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Re-Opened</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '4'  && buildObject(data.item.content, data.item.dotCss) as Comment">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '5' && buildObject(data.item.content, data.item.dotCss) as Action">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '6' && buildObject(data.item.content, data.item.dotCss) as Comment">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '7' && buildObject(data.item.content, data.item.dotCss) as Action">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Completed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '8' && buildObject(data.item.content, data.item.dotCss) as Rule">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Disabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '9' && buildObject(data.item.content, data.item.dotCss) as Rule">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Re-Enabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                </div>
                            </div>
                            <div class="timeline-element"
                                *ngIf="data.item.dotCss == '10' && buildObject(data.item.content, data.item.dotCss) as RuleEdit">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Changed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Previous Conditions</span>
                                    <span class="timeline-item-title">New Conditions</span>
                                    <span class="timeline-item-title">Changed By</span>
                                    <span>{{RuleEdit.PreviousConditions}}</span>
                                    <span>{{RuleEdit.NewConditions}}</span>
                                    <span>{{RuleEdit.UserID}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-timeline>
    </div>
</ng-template>